// setup states
export const ORG_SETUP_NEEDS_SYNC = 'needs_sync';
export const ORG_SETUP_INITIAL = 'initial';
export const ORG_SETUP_NEEDS_AUTH = 'needs_auth';
export const ORG_SETUP_SYNCING = 'syncing';
export const ORG_SETUP_SYNC_ERROR = 'sync_error';
export const ORG_SETUP_COMPLETE = 'complete';
export const ORG_SETUP_INTERMISSION = 'intermission';

// crm types
export const ON_PREM_CRM = 'on-prem';
export const NXT_CRM = 'nxt';
export const DEMO_CRM = 'demo';
export const SPS_CRM = 'sps';
export const DONORPERFECT_CRM = 'donorperfect';
export const OTHER_CRM = 'other';

// feature packages

// all the features:
export const STANDARD_PACKAGE = 'standard';

// simplified app: no stage selection, no team view, etc
export const STARTER_PACKAGE = 'starter';



// WEBPACK FOOTER //
// ./src/utils/authOrg.constants.js